import React, { useEffect, useState } from "react";
import { Col, Button, Row } from "reactstrap";
import { Colors,
    OutputRow,
    BoldLabel,
    LeftLabel,
    HighlightedCost,
    TableTitle,
    WhiteTableContainer,
    UnderlineButton,} from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";

import AccommodationRow from "../../experiences/cost-summary/exp-accommodation-row";
import FlightRow from "../../experiences/cost-summary/exp-flight-row";
import ActivityRow from "../../experiences/cost-summary/exp-activity-row";
import TransportationRow from "../../experiences/cost-summary/exp-transportation-row";
import MealsRow from "../../experiences/cost-summary/exp-meals-row";
import MiscellaneousRow from "../../experiences/cost-summary/exp-miscellaneous-row";
import FinalCostRow from '../../experiences/cost-summary/final-cost-row';
import ContingencyRow from "../../experiences/cost-summary/exp-contingency-row";
import { displayValue } from "../../helper";
import { calculateSubCostPerAttendee,
    calculateTotalCostPerAttendee,
    calculateSubCostNoFlightsPerAttendee,
    calculateCostPerAttendee, } from "../../experiences/cost-summary/cost-helper";
import MeetingsRow from "../../experiences/cost-summary/exp-meetings.row";
import styled from "styled-components";
import CostOutput from "./rebel-cost-output";
import { getAccommodationBreakdown } from "../../experiences/cost-summary/cost-helper";

const CostSummary = ({guideData, expData}) => {

    const [clientCurrency, setClientCurrency] = useState(true);
    const breakdown = getAccommodationBreakdown(guideData, expData);

    const toggleCurrency = (value) => {
        setClientCurrency(value);
    }

    const activeButton = {
        backgroundColor: RebelColors.gold,
        border: "2px solid" + RebelColors.gold,
        borderRadius: "0px",
        color: "#000000"
    }
    const inactiveButton = {
        backgroundColor: "transparent",
        color: RebelColors.text,
        border: "2px solid" + RebelColors.border,
        borderRadius: "0px"
    }

    const expDataRX = {...expData, base: {value: 1, invalid: false, required: true}, convert: {value: 1, invalid: false, required: true}};
    const guideDataRX = {...guideData, currency: {value: expData.destCurrency.value, invalid: false, required: true}};

    // Check if currencies are the same (e.g., USD/USD)
    const sameCurrency = guideData.currency.value === expData.destCurrency.value;

    return (
            <React.Fragment>
            {guideData && expData && <React.Fragment>
                <Row>
                    <Col>
                        <h2 style={{color: RebelColors.gold, marginRight: "20px"}}>Cost Summary</h2>
                    </Col>
                    <Col style={{display: "flex", justifyContent:"flex-end", paddingRight: "30px"}}>
                    </Col>
                </Row>

                <br/>

                <h3 style={{color: RebelColors.gold}}>{expData.title.value}, {expData.location.value}</h3>
                {(expData.numberOfBedrooms?.value || expData.distanceFromAirport?.value || expData.nearestCity?.value || expData.distanceToCity?.value || expData.villaURL?.value) && (
                    <VillaDetailsContainer>
                        {expData.numberOfBedrooms?.value > 0 && <VillaDetail><strong>Bedrooms:</strong> {expData.numberOfBedrooms.value}</VillaDetail>}
                        {expData.distanceFromAirport?.value && <VillaDetail><strong>Distance from Airport:</strong> {expData.distanceFromAirport.value}</VillaDetail>}
                        {expData.nearestCity?.value && <VillaDetail><strong>Nearest City:</strong> {expData.nearestCity.value}</VillaDetail>}
                        {expData.distanceToCity?.value && <VillaDetail><strong>Distance to City:</strong> {expData.distanceToCity.value}</VillaDetail>}
                        {expData.villaURL?.value && (
                            <ViewPropertyButton
                                href={expData.villaURL.value.startsWith('http') ? expData.villaURL.value : `https://${expData.villaURL.value}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View Property
                            </ViewPropertyButton>
                        )}
                    </VillaDetailsContainer>
                )}
                {breakdown && breakdown.warnings.length > 0 && (
                    <WarningsContainer>
                        {breakdown.warnings.map((warning, i) => (
                            <WarningBadge key={i} $type={warning.type}>
                                {warning.type === 'blackout' ? '!' : warning.type === 'callToBook' ? '!' : '!'}
                                {' '}{warning.message}
                            </WarningBadge>
                        ))}
                    </WarningsContainer>
                )}
                {breakdown && breakdown.discount.applied && (
                    <DiscountBadge>
                        Discount applied: {breakdown.discount.description}
                    </DiscountBadge>
                )}
                {!sameCurrency && (
                    <Row>
                        <Col>
                            <PrimaryButton
                                style={clientCurrency ? activeButton : inactiveButton}
                                onClick={() => toggleCurrency(true)}
                            >
                                {guideData.currency.value}
                            </PrimaryButton>
                            <PrimaryButton
                                style={!clientCurrency ? activeButton : inactiveButton}
                                onClick={() => toggleCurrency(false)}
                            >
                                {expData.destCurrency.value}
                            </PrimaryButton>
                        </Col>
                    </Row>
                )}
           <br/>
                { clientCurrency && <CostOutput clientCurrency={clientCurrency} guideData={guideData} expData={expData} currencyConversionRatio={expData.base.value / expData.convert.value}/>}
                {!clientCurrency && <CostOutput clientCurrency={clientCurrency} guideData={guideDataRX} expData={expDataRX} currencyConversionRatio={expData.base.value / expData.convert.value}/>}
            </React.Fragment>}

        </React.Fragment>
    )
}

export default CostSummary;


const PrimaryButton = styled(Button)`
    color: ${props => props.style?.color || RebelColors.primary};
    &:hover {
        opacity: 0.8;
    }
`

const VillaDetailsContainer = styled.div`
    background: linear-gradient(135deg, #000000 0%, #1f2937 50%, #374151 100%);
    border: 1px solid rgba(253, 181, 6, 0.3);
    border-radius: 12px;
    padding: 20px;
    margin: 16px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
`

const VillaDetail = styled.div`
    color: ${RebelColors.text};
    font-size: 14px;
    padding: 6px 14px;
    background: linear-gradient(135deg, rgba(253, 181, 6, 0.1) 0%, rgba(253, 181, 6, 0.05) 50%, transparent 100%);
    border: 1px solid rgba(253, 181, 6, 0.2);
    border-radius: 6px;

    strong {
        color: ${RebelColors.gold};
        margin-right: 4px;
    }
`

const WarningsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 12px 0;
`

const WarningBadge = styled.div`
    background: ${props => {
        if (props.$type === 'blackout') return 'rgba(239, 68, 68, 0.15)';
        if (props.$type === 'callToBook') return 'rgba(251, 191, 36, 0.15)';
        return 'rgba(251, 191, 36, 0.1)';
    }};
    border: 1px solid ${props => {
        if (props.$type === 'blackout') return '#ef4444';
        if (props.$type === 'callToBook') return '#fbbf24';
        return '#fbbf24';
    }};
    color: ${props => {
        if (props.$type === 'blackout') return '#ef4444';
        if (props.$type === 'callToBook') return '#fbbf24';
        return '#fbbf24';
    }};
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
`

const DiscountBadge = styled.div`
    background: rgba(16, 185, 129, 0.15);
    border: 1px solid #10b981;
    color: #10b981;
    padding: 8px 14px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    margin: 12px 0;
    display: inline-block;
`

const ViewPropertyButton = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 8px 20px;
    background: linear-gradient(90deg, #fdb506 0%, #f59e0b 100%);
    border: 2px solid #fdb506;
    border-radius: 6px;
    color: #000000 !important;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover, &:visited, &:active, &:focus {
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(253, 181, 6, 0.4);
        color: #000000 !important;
        text-decoration: none;
    }
`
